import { fetchAuthSession } from 'aws-amplify/auth';
import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useSessionStore } from 'session/useSessionStore';
import { LoginLoader } from './LoginLoader';
import { hexToString } from 'features/seismic/utils/seismicUrlUtils';

export const CognitoCallbackHandler = () => {
    const navigate = useNavigate();
    const setJwt = useSessionStore(state => state.setJwtToken);

    useEffect(() => {
        //needs time for cognito lib to set auth stuff before redirecting
        (async () => {
            try {
                //const session = await fetchAuthSession();
                //const idToken = session.tokens?.idToken?.toString();
                //setJwt(idToken ?? '');
                const params = new URLSearchParams(window.location.search);
                const rawState = params.get('state');
                if (!!rawState) {
                    const stateContent = rawState.split(';')[1];
                    // eslint-disable-next-line no-restricted-globals
                    history.replaceState({}, '', window.location.protocol + '//' + window.location.host + stateContent);
                    navigate(stateContent!);
                    /*setTimeout(async () => {
                        const session = await fetchAuthSession();
                        debugger;
                        // eslint-disable-next-line no-restricted-globals
                        //
                        const jwt = session.tokens?.idToken?.toString();
                    }, 5000);*/

                    //setTimeout(() => navigate(decodedState!), 1000);
                }
            }
            catch {  }
        })();
    }, [navigate]);

    return (
        <LoginLoader withCallback={false}/>
    );
};